const VISIBLE_SLIDES_BREAKPOINT_1 = 1.1;
const VISIBLE_SLIDES_BREAKPOINT_2 = 2.1;
const CAROUSEL_BREAKPOINT_1 = 768;
const CAROUSEL_BREAKPOINT_2 = 1024;
const MEDIA_QUERY_MATCH = `(max-width: ${CAROUSEL_BREAKPOINT_2}px) and (min-width: ${CAROUSEL_BREAKPOINT_1}px)`;
export { VISIBLE_SLIDES_BREAKPOINT_1, VISIBLE_SLIDES_BREAKPOINT_2, CAROUSEL_BREAKPOINT_1, CAROUSEL_BREAKPOINT_2, MEDIA_QUERY_MATCH };